<!-- Navbar Section-->
<nav class="navbar navbar-inverse hidden-xs">
  <div class="container-fluid" style="padding-left: 15px;padding-right: 15px">
    <div class="navbar-header">
      <button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#myNavbar">
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
      <div style="margin-top: 7px;">
        <a class="" style="color: #ffffff;font-size: 25px;text-decoration: none">
          <!--        <img src="../../assets/images/camden-logo.png" alt="Logo" class="img-responsive">-->
          Camden Health System.
        </a>
      </div>
    </div>
    <div class="collapse navbar-collapse" id="myNavbar">

      <ul class="nav navbar-nav navbar-right">
        <li><a href="#mainSection">Home</a></li>
        <li><a href="#hmis">HMIS</a></li>
        <li><a href="#partners">Partners</a></li>
        <li><a href="#aboutUs">About</a></li>
        <li class="blog-link" [routerLink]="['/insights']">Insights</li>
        <li><a href="#contact">Contact</a></li>
        <!--        <li><a data-target="#" [routerLink]="['/blogs']">Insights</a></li>-->
      </ul>
    </div>
  </div>
</nav>

<!-- Sidebar Section-->
<section class="visible-xs">

  <div id="mySidenav" class="sidenav">
    <a href="javascript:void(0)" class="closebtn" (click)="closeNav()" >&times;</a>
<!--    href="#home"-->
    <a (click)="closeNav()" href="#mainSection">Home</a>
    <a  (click)="closeNav()" href="#hmis">HMIS</a>
    <a (click)="closeNav()" href="#partners">Partners</a>
    <a  (click)="closeNav()" href="#aboutUs">About</a>
    <a (click)="closeNav()" routerLink="insights">Insights</a>
    <a (click)="closeNav()" href="#contact">Contact</a>
    <!--  <a href="#home">Insights</a>-->
  </div>

  <div class="row" style="background-color: transparent;margin: 0px;position: absolute;width: 100%;">
    <div class="col-xs-12 text-center">
      <span style="font-size:30px;cursor:pointer;color: #ffffff;margin-left: 10px;float: left;margin-top: 3px;" (click)="openNav()">&#9776;</span>

      <!--      <a routerLink="/" style="float: none; display: inline-block;">-->
      <!--        <img src="../../assets/images/camden-logo.png" alt="Logo" class="img-responsive"></a>-->
      <div style="display: flex;justify-content: center;align-items: center;margin-top: 7px;">
        <a class="sidebar-title" style="color: #ffffff;">Camden Health System.</a>
      </div>
    </div>
  </div>


</section>

<!--Main Section-->
<section id="mainSection" class="mainSection container-fluid">
  <div class="mainImage">
  </div>
</section>


<!-- HMIS Section-->
<section id="hmis" class="hmisSection">

  <div class="container hims-container">

    <div class="row m-0">
      <h2><b>Camden HMIS</b></h2>
    </div>

    <div class="row mt-10">

      <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">

        <div style="text-align: center">
          <ul class="nav nav-pills">
            <li class="active first-tab"><a data-toggle="pill" href="#intro" style="flex-direction: column"><div><i class="fas fa-clipboard-list"></i></div><div>Introduction</div></a></li>
            <li><a data-toggle="pill" href="#clinical" style="flex-direction: column"><div><i class="fas fa-clinic-medical"></i></div><div>Clinical</div></a></li>
            <li><a data-toggle="pill" href="#diagnostics" style="flex-direction: column"><div><i class="fas fa-stethoscope"></i></div><div>Diagnostics</div></a></li>
            <li><a data-toggle="pill" href="#administration" style="flex-direction: column"><div><i class="fas fa-user-cog"></i></div><div>Administration</div></a></li>
            <li><a data-toggle="pill" href="#financials" style="flex-direction: column"><div><i class="fas fa-coins"></i></div><div>Financials</div></a></li>
            <li><a data-toggle="pill" href="#analyticstab" style="flex-direction: column"><div><i class="fas fa-chart-bar"></i></div><div>Analytics</div></a></li>
            <li><a data-toggle="pill" href="#telemedicinetab" style="flex-direction: column"><div><i class="fas fa-mobile"></i></div><div>Telemedicine</div></a></li>
            <!--            <li><a data-toggle="pill" href="#misc">Misc.</a></li>-->
          </ul>
        </div>

      </div>

      <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12" style="text-align: center">
        <div class="tabContentArea">

          <div class="tab-content">

            <div id="intro" class="tab-pane fade in active">

              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 cat-text">
                <p><strong>Transforming healthcare in emerging markets</strong></p>

                <p>What started as a single patient registration form has now evolved into Camden health system consisting of several advanced clinical and non-clinical modules.  We offer healthcare solutions to public and private sectors that are affordable, scalable and easy to use.</p>

                <p>CHS is available as on-premise, cloud based or hybrid solution. We follow international & local standards (ICD-10, PHCC etc.) and follow HIPPA rules and regulations. </p>

              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 cat-img">
                <!--                <div class="embed-responsive embed-responsive-16by9">-->
                <!--                <div style="width: 100%">-->
                <!--                <iframe class="camden-video" src="https://youtube.com/embed/r4OPHc6JDng" frameborder="0"></iframe>-->
                <img src="../../assets/new-images/new-Introduction.png" alt="" class="img-responsive hmis-images">
                <!--                </div>-->
                <!--                </div>-->
              </div>

            </div>

            <div id="clinical" class="tab-pane fade">

              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 cat-text">

                <p><strong>Patient registration, Emergency, in-patient & OPD, Operation theatre, Dialysis management & more.</strong></p>

                <p>Camden HMIS work flows and interfaces have been designed & developed by engineers & developers with contributions from physicians, nurses & other paramedical staff. Our HMIS solutions offers unprecedented level of customization while simultaneously following industry standards and compliances. </p>

                <p>All CHS clinical modules help you position your organization for better patient care management and experience.</p>

              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 cat-img">
                <img src="../../assets/new-images/new-Clinical.jpg" alt="" class="img-responsive hmis-images">
              </div>

            </div>

            <div id="diagnostics" class="tab-pane fade">

              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 cat-text">

                <p><strong>Laboratory Information System (LIS), Radiology Information & Picture Archiving and Communication System (RIS/PACS)</strong></p>

                <p>CHS diagnostics automate manual processes, increase efficiency, reduce turnaround times. Core LIMS features include sample management, instrument integration & data exchange. CHS also offers online status, verification & results. CHS is capable of handling variety of test configurations and high-volume testing.</p>

                <p>Our multimodality PACS offers convenient access to radiology images and comprehensive report functionality.</p>

              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 cat-img">
                <img src="../../assets/new-images/new-Diagnostics.png" alt="" class="img-responsive hmis-images">
              </div>

            </div>

            <div id="administration" class="tab-pane fade">

              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 cat-text">

                <p><strong>Human Resource, Organization Plan, Complaint Management, Medical Record Management</strong></p>

                <p>Automation helps to manage general processes and also ensures a better working environment for all employees. Administrative modules in our HMIS enable collaboration and reduce the time required to carry-out managerial tasks. </p>

                <p>Our solution allows quick and error-free decision making and makes it possible to address administrative issues efficiently, thereby bringing visible improvement in operations and administration.</p>

              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 cat-img">
                <img src="../../assets/new-images/new-Administration.jpg" alt="" style="margin-top: 10px" class="img-responsive hmis-images">
              </div>

            </div>

            <div id="financials" class="tab-pane fade">

              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 cat-text">

                <p><strong>Billing, Finance & Accounts, Inventory & Fixed Assets Management</strong></p>

                <p>Our clinical and non-clinical modules are flexible enough to be integrated with your existing financial modules. Like all of our other modules, CHS pharmacy management can be operated independently in one or multiple pharmacies. Features include POS, stocking and alerts.</p>

                <p>Aimed at covering even the most demanding needs, our modular architecture and industry-specific adaptation allows us to provide coverage to all types of healthcare organizations regardless of their size.</p>

              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 cat-img">
                <img src="../../assets/new-images/Financials.png" alt="" class="img-responsive hmis-images">
              </div>

            </div>

            <div id="analyticstab" class="tab-pane fade">

              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 cat-text">

                <p><strong>Performance monitoring, Disease Surveillance, Business Intelligence & Insights</strong></p>

                <p>Camden HMIS analytics is helping organizations in achieving better financial & patientcare management. Our customized reports enable administrators to monitor staff attendance, quality of work, revenue and margins. </p>

                <p>Machine learning and business intelligence offer unprecedented ability to analyze data that. We are also working on monitoring disease patterns, outbreak prediction for better public care models. </p>

              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 cat-img">
                <img src="../../assets/new-images/new-Analytics.png" alt="" class="img-responsive hmis-images">
              </div>

            </div>

            <div id="telemedicinetab" class="tab-pane fade">

              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 cat-text">

                <p><strong>Democratizing healthcare through telemedicine </strong></p>

                <p>Camden Health HMIS is offered as on-premise, cloud-based or hybrid solution. This enables patients and healthcare professionals to access medical record from anywhere. We are now adding features including real time secure and private conference between patients and physicians. </p>

                <p>Telemedicine offers a unique opportunity of empowering people in developing countries particularly women in accessing and keeping track of their own health.</p>


              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 cat-img">
                <img src="../../assets/new-images/Telemedicine.png" alt="" style="margin-top: 10px;" class="img-responsive hmis-telemedicine-image">
              </div>

            </div>

          </div>

        </div>
      </div>

    </div>

    <div class="row m-0">

      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">


      </div>

    </div>

  </div>

</section>


<!--About Us Section-->
<section id="aboutUs">

  <div class="container aboutUs-container">

    <div class="row m-0">
      <h2><b>About</b></h2>
    </div>

    <div class="row m-0">

      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 text-justify">

        <p>Low and middle-income countries bear 90% of the world’s diseases but compose only 12% of health expenditures. Digitizing healthcare in emerging markets is the most efficient way to improve public health services. However, IT solutions are expensive and rely on customization and stable infrastructure which makes them almost non-existent in developing countries.</p>

        <p>Camden Health System offers affordable, scalable and secure IT solutions for public health management, monitoring and research in these markets.</p>

        <p>From specialized HMIS modules to personal and social health management, we are now working on offering customized healthcare solutions in 4 major domains. This would be the foundation of AI based global healthcare analytics and a major step towards improving global health index and curbing next COVID like pandemic.</p>

        <!--        <p>Low and middle-income countries bear 90% of the world’s diseases but compose only 12% of health expenditures. To improve global health index & curb next COVID like pandemic, it is imperative to digitize healthcare in emerging markets that improves public health and provides accurate healthcare analytics.</p>-->

        <!--        <p>IT solutions are expensive and rely heavily on customization and stable infrastructure. Because of these reasons they are almost non-existent in developing countries. Camden Health System has been established to offer affordable, scalable and secure IT solutions for public health management, monitoring and research in these markets.</p>-->

        <!--        <p>From specialized HMIS modules to personal and social health management, we are now working on offering healthcare solutions in 4 major domains. This would be the foundation of AI based global healthcare analytics.</p>-->

      </div>

      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
        <img src="../../assets/new-images/Camden%20HMIS%20-%20World%20Disease%20Burden%20ii.jpg" alt="" style="width: 100%;" class="img-responsive">
      </div>

    </div>

    <div class="row abouts-small-sections m-0">

      <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 widgets">
        <div class="text-center" style="font-size: 30px;"><i class="fas fa-laptop-medical"></i></div>
        <h4>HMIS</h4>
        <p>Clinical, Non Clinical, Specialized Modules</p>
      </div>

      <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 widgets">
        <div class="text-center" style="font-size: 30px;"><i class="fas fa-heartbeat"></i></div>
        <h4>Health Management</h4>
        <p>Personal & Social Heath Apps, Hardware Integration</p>
      </div>

      <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 widgets">
        <div class="text-center" style="font-size: 30px;"><i class="fas fa-globe-asia"></i></div>
        <h4>Telemedicine</h4>
        <p>Remote Consultation, Assistance & Monitoring</p>
      </div>

      <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 widgets">
        <div class="text-center" style="font-size: 30px;"><i class="fa fa-chart-line"></i></div>
        <h4>Analytics & AI</h4>
        <p>Global Health Trends, Forecasting, Alerts & R&D</p>
      </div>

    </div>

  </div>

</section>



<!--Partners section-->
<section id="partners">
  <div class="container partners-container">

    <div class="row m-0">
      <h2><b>Partners</b></h2>
    </div>

    <div class="row partners-text m-0">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12 text-justify">
        <p>In just over 5 years, Camden Health HMIS has established itself as the most trusted healthcare technology brand in the country. Today, we proudly serve over 20 of the country’s leading private hospitals, delivering reliable, innovative, and patient-focused digital solutions.</p>
      </div>
    </div>

    <div class="row m-0">

      <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 text-center margin-block">
        <div>
          <img src="assets/new-images/Hameed%20Latif%20Camden%20Health%20(1).jpg" width="100%" height="100%" class="img-responsive" alt="">
        </div>
        <h4 style="font-weight: bold">Hameed Lateef Hospital</h4>
        <p>450 Beds</p>
      </div>

      <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 text-center img-block block-image-margin">
        <div>
          <img src="assets/new-images/National%20Hospital%20Camden%20Health.jpg" width="100%" height="100%" class="img-responsive" alt="">
        </div>
        <h4 style="font-weight: bold">National Hospital</h4>
        <p>350 Beds</p>
      </div>

      <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 text-center img-block block-image-margin">
        <div>
          <img src="assets/new-images/farooq-Hospital.jpeg" width="100%" height="100%" class="img-responsive" alt="">
        </div>
        <h4 style="font-weight: bold">Farooq Hospital</h4>
        <p>350 Beds</p>
      </div>

      <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 text-center margin-block">
        <div>
          <img src="assets/new-images/University%20of%20Lahore%20Camden%20Health.jpg" width="100%" height="100%" class="img-responsive" alt="">
        </div>
        <h4 style="font-weight: bold">UoLT Hospital</h4>
        <p>500 Beds</p>
      </div>

    </div>
  </div>

  <div class="container" style="padding-top: 7px;
    padding-left: 50px;
    padding-right: 50px;" *ngIf="partnersData.length > 0">
    <div class="clientSlider owl-carousel owl-theme">
      <div class="clientSliderItem" *ngFor="let data of partnersData">
        <div class="homeSection3">
          <img src="{{apiAddress + data?.partner_image?.url}}" alt="" style="width: 100%;" class="img-responsive">
          <div class="content">
            <p class="text-center">{{data?.name}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


<!-- Insights Section -->
<section id="homes" class="homeSection">

  <div class="container blog-area">

    <div class="row m-0">
      <h2><b>Insights</b></h2>
    </div>



    <!--    d-none d-sm-none d-md-flex   hidden-xs hidden-sm visible-md -->
<!--    <div class="row mt-3 hidden-xs" style="margin-top: 30px!important;">-->

<!--      <ng-container *ngFor="let blog of blogData;let i = index">-->
<!--        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4" *ngIf="i < 6">-->
<!--          <div class="first-blog">-->
<!--            <a routerLink="/insights/{{blog.url}}"><img src="{{apiAddress + blog.image_url}}" alt="" style="width: 100%;" class="img-responsive"></a>-->
<!--            <div class="content">-->
<!--              <p>{{blog.name}}</p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </ng-container>-->

<!--    </div>-->

<!--    d-block d-sm-block d-md-none-->
<!--    <div class="story-slider owl-carousel owl-theme visible-xs">-->
<!--      <ng-container *ngFor="let date of blogMobileData;let i = index">-->
<!--        <div class="item ml-0" *ngIf="i < 3">-->
<!--          <div class="first-blog" *ngFor="let blog of date">-->
<!--            <a routerLink="/insights/{{blog.url}}"><img src="{{apiAddress + blog.image_url}}" alt="" style="width: 100%;" class="img-responsive"></a>-->
<!--            <div class="content">-->
<!--              <p>{{blog.name}}</p>-->
<!--            </div>-->
<!--          </div>-->

<!--        </div>-->
<!--      </ng-container>-->
<!--    </div>-->


    <div class="row mt-10">


      <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 padding-home" *ngIf="blogData[0]">
        <div class="homeSection1">
          <!--          <a routerLink="/fighting-corona-we-are-at-the-forefront"><img src="../../assets/images/Blog-2.jpg" alt="" style="width: 100%;" class="img-responsive"></a>-->
          <a routerLink="/insights/{{blogData[0]?.url}}">
            <img src="{{apiAddress + blogData[0]?.image_url}}" alt="" style="width: 100%;" class="img-responsive">
          </a>
          <div class="content">
            <p>{{blogData[0]?.name}}</p>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
        <div class="homeSection2" *ngIf="blogData[1]">
          <a routerLink="/insights/{{blogData[1]?.url}}"><img src="{{apiAddress + blogData[1]?.image_url}}" alt="" style="width: 100%;" class="img-responsive"></a>
          <div class="content">
            <p>{{blogData[1]?.name}}</p>
          </div>
        </div>
        <div class="homeSection3" *ngIf="blogData[2]">
          <a routerLink="/insights/{{blogData[2]?.url}}"><img src="{{apiAddress + blogData[2]?.image_url}}" alt="" style="width: 100%;" class="img-responsive"></a>
          <div class="content">
            <p>{{blogData[2]?.name}}</p>
          </div>
        </div>
      </div>
    </div>

    <p class="text-right mt-10"><a style="text-decoration: none;color: black" routerLink="/insights">More Insights ...</a></p>
  </div>

</section>


<!-- Contact Section-->
<section id="contact" class="contact-Section">

  <div class="container">

    <div class="row m-0">
      <h2 class="m-t-25"><b>Contact</b></h2>
    </div>

    <div class="row m-0">

      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 contact-text">

        <p>
          Camden Health System products are designed, developed and owned by Camden Health System.  Our vision is to empower people & improve their health and wellbeing particularly in emerging markets by supporting integration of digital technology in all areas of services and businesses.
        </p>

        <p>For demo, product or any other information fill up the form or email us at info@camdenhealthsys.com</p>

        <p><strong>Camden Health System</strong> <br>
          USA: 7221 Swallow Branch Lane Plano, TX 75025  <br>
          Pakistan: 104, Block J, M.A Johar Town, Lahore</p>

        <p> <a href="mailto:info@camdenhealthsys.com">info@camdenhealthsys.com</a> | <a href="https://camdenhealthsys.com/">www.camdenhealthsys.com</a></p>

      </div>

      <!--      form-area-->
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 contact-form">

        <form>


          <div class="row">

            <div class="col-md-6 col-sm-6 col-xs-12">
              <input  [(ngModel)]="name" name="name" type="text" class="form-control" placeholder="Full Name*">
            </div>

            <div class="col-md-6 col-sm-6 col-xs-12 left-padding-input">
              <input [(ngModel)]="email" name="email" type="email" class="form-control" placeholder="Email*">
            </div>

            <div class="col-md-6 col-sm-6 col-xs-12">
              <input  type="text" class="form-control" name="phone" [(ngModel)]="phone" placeholder="Contact" (keypress)="onlyNumeric($event)">
            </div>

            <div class="col-md-6 col-sm-6 col-xs-12 left-padding-input">
              <select [(ngModel)]="topic" name="topic">
                <option value="">Topic*</option>
                <option value="Demo">Demo</option>
                <option value="Pricing">Pricing</option>
                <option value="Consultation">Consultation</option>
                <option value="Others">Others</option>
              </select>
            </div>

          </div>

          <div class="row">
            <div class="col-xs-12">
              <textarea  [(ngModel)]="message" name="message" rows="5" placeholder="Your comments*"></textarea>
            </div>
          </div>

          <div style="text-align: center;">
            <button class="btn btn-primary submit-btn" (click)="onSubmit()" type="button">SEND</button>
          </div>

        </form>

      </div>

    </div>

  </div>

</section>


<!-- Footer Section-->
<section class="footer-section ">

  <div class="container-fluid">
    <div class="row">

      <div class="col-xs-12 col-sm-6">
        <p class="pt-15" style="color: white">© 2024 Copyrights Reserved | Designed by <a href="https://camdenhealthsys.com/" target="_blank">Camden Health System</a></p>
      </div>

      <div class="col-xs-12 col-sm-6 pages-row support" style="color: white">
        <a routerLink="/disclaimer" style="margin-right: 5px;">Disclaimer</a>|
        <a routerLink="/privacy-policy">Privacy Policy</a>
      </div>

    </div>
  </div>

</section>
